import { downloadTableReportPdf } from './report-table-pdf';
import { TRAVEL_COMPANY } from './report-company';

export async function downloadTravelReportPdf(
  rows: Record<string, string | number | null | undefined>[],
  title: string,
  params: string[],
  filename: string
) {
  const keys = Object.keys(rows[0] ?? {});
  await downloadTableReportPdf(
    {
      company: TRAVEL_COMPANY,
      title,
      params,
      generatedLabel: new Date().toLocaleString('tr-TR'),
      columns: keys.map((key) => ({
        key,
        header: key,
        num: rows.some((row) => typeof row[key] === 'number'),
        width: /ad|name|cari/i.test(key) ? 26 : 14,
      })),
      rows: rows.map((cells) => ({ cells })),
    },
    filename
  );
}
